var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"transform":_vm.screenScale}},[_c('circle',{attrs:{"r":_vm.r,"fill":"red","stroke":"white","stroke-width":_vm.strokeWidth}}),_vm._v(" "),_c('text',{staticClass:"no-pointer",attrs:{"font-size":_vm.fontSize,"fill":"white","text-anchor":"middle","y":_vm.textY}},[_vm._v(_vm._s(_vm.symbol))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5504d70c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RoutePoint.vue
// module id = h1eN
// module chunks = 1